import React from "react";

import "../../tokens/tokens.css";
import "./index.css";

const STATUS_CONFIG = {
  done: { className: "v2-badge-done", label: "✓ Done" },
  flagged: { className: "v2-badge-flagged", label: "× Flagged" },
  pending: { className: "v2-badge-pending", label: "— Pending" },
  not_submitted: { className: "v2-badge-not-submitted", label: "Not submitted" },
};

/**
 * V2Badge — Rapsap Operations "matrix status" pill: Done / Flagged / Pending / Not sub.
 *
 * Deliberately a plain <span>, not antd's Tag: src/components/Badge/index.css
 * globally forces every `.ant-tag` lacking antd's own color classes
 * (ant-tag-green/-red/-...) to a flat gray/black with `!important`, which
 * would silently stomp all four of our states. Nothing about Tag's own
 * behavior (close button, icon slot) is used here, so a plain element
 * sidesteps the conflict instead of fighting it with more `!important`.
 *
 * `status` picks the color (green/red/gray/blue); `label` optionally
 * overrides the displayed text — e.g. `status="flagged" label="Critical"`
 * reuses the "flagged" red for a differently-worded status elsewhere
 * (role/worker progress uses not_started/in_progress/completed/critical,
 * not the matrix's own vocabulary).
 */
export default function V2Badge({ status, label, dimmed = false, className = "" }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.pending;
  const dimmedClass = dimmed ? "v2-badge-dimmed" : "";
  return (
    <span className={`v2-badge ${config.className} ${dimmedClass} ${className}`.trim()}>
      {label ?? config.label}
    </span>
  );
}
